import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { theme } from "./theme";

// import { Navbar } from './components/navbar'
import CustomSwitch from "./components/custom-switch";

import PrivateRoute from './components/routing/PrivateRoute'
import useNotifier from "./services/useNotifier";
import { getToken } from "./redux/user/user.actions";
import { useDispatch } from "react-redux";
import RedirectRoute from "./components/routing/RedirectRoute";
import { Spinner } from "./components/spinner";
import { ErrorBoundary } from "./components/error-boundary";

// const LinksGuide = lazy(() => import("./pages/links-guide"))
const LandingPage = lazy(() => import("./pages/landing-page"))
const SignIn = lazy(() => import("./pages/sign-in"))
const SignUp = lazy(() => import("./pages/sign-up"))
const RegistrationType = lazy(() => import("./pages/registration-type"))
const ForgotPassword = lazy(() => import("./pages/forgot-password"))
const ForgotPasswordVerification = lazy(() => import('./pages/forgot-password/verification'))
const MentorSignUp = lazy(() => import("./pages/sign-up/mentor"))
const MentorshipPage = lazy(() => import("./pages/mentorship"))
const CoursesPage = lazy(() => import("./pages/courses"))
const ScholarshipAuth = lazy(() => import("./pages/scholarship"))
const Profile = lazy(() => import("./pages/profile"))
const BookMarksPage = lazy(() => import("./pages/bookmarks"))
const WalletPage = lazy(() => import("./pages/wallet"))
const UserMentors = lazy(() => import("./pages/mentors"))
const MentorPricingPage = lazy(() => import("./pages/mentors/pricing"))

const App = () => {

  useNotifier()
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(getToken())
  }, [dispatch])

  return (
    <ThemeProvider theme={theme}>
      <Router>

        <CustomSwitch>
          <ErrorBoundary>
            <Suspense fallback={<Spinner />}>
              {/* <RedirectRoute exact path='/home' component={LandingPage} /> */}
              <RedirectRoute exact path='/signin' component={SignIn} />
              <RedirectRoute exact path='/register/student' component={SignUp} />
              <RedirectRoute exact path='/' component={LandingPage} />

              <RedirectRoute exact path='/register/mentor' component={MentorSignUp} />
              <RedirectRoute exact path='/register/type' component={RegistrationType} />
              <RedirectRoute exact path='/forgot-password' component={ForgotPassword} />
              <RedirectRoute exact path='/forgot-password/verifcation' component={ForgotPasswordVerification} />
              <RedirectRoute exact path='/mentorship' component={MentorshipPage} />
              <PrivateRoute exact path='/courses' component={CoursesPage} />
              <PrivateRoute exact path='/scholarship-auth' component={ScholarshipAuth} />
              <PrivateRoute exact path='/profile/myprofile' component={Profile} />
              <PrivateRoute exact path='/profile/bookmarks' component={BookMarksPage} />
              <PrivateRoute exact path='/profile/wallet' component={WalletPage} />
              <PrivateRoute exact path='/profile/mentors' component={UserMentors} />
              <PrivateRoute exact path='/profile/mentors/pricing' component={MentorPricingPage} />
            </Suspense>
          </ErrorBoundary>
        </CustomSwitch>

      </Router>
    </ThemeProvider>
  )
}

export default App;
